import { cx } from '@emotion/css';
import dayjs from 'dayjs';

import { useNavigator } from '../../routing/navigator';
import { Receipt } from '../../shared/types/server-types';
import { PaymentTypeEnum, ReceiptStatusEnum } from '../../shared/types/enums';

import {
  historyListStyle,
  listItem,
  listItemContainerStyle,
  listItemTopContainerStyle,
  locationNameStyle,
  paymentStatusStyle,
  pendingPaymentStyle,
} from './HistoryPage';

interface ReceiptsProps {
  receipts: Receipt[];
}

export const ReceiptsList = (props: ReceiptsProps): JSX.Element => {
  const { receipts } = props;
  const navigator = useNavigator();

  const sorted = [...receipts].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  );

  return (
    <ul className={historyListStyle}>
      {sorted.map((receipt, index) => {
        const total = receipt.items.reduce(
          (sum, item) => item.consumption * item.tariff + sum,
          0,
        );

        return (
          <li key={index}>
            <button
              type="button"
              className={listItem}
              onClick={() => navigator.toReceiptDetails(receipt.id)}
            >
              <div
                className={cx(
                  listItemContainerStyle,
                  listItemTopContainerStyle,
                )}
              >
                <span>
                  {receipt.paymentType === PaymentTypeEnum.PERIODICAL
                    ? `${dayjs(receipt.periodStartDate).format('DD.MM.YYYY.')} - ${dayjs(receipt.periodEndDate).format('DD.MM.YYYY.')}`
                    : dayjs(receipt.periodEndDate).format('DD.MM.YYYY.')}
                </span>
                <span>{total.toFixed(2)} EUR</span>
              </div>
              <div className={listItemContainerStyle}>
                <span className={locationNameStyle}>
                  {receipt.account.location.name}
                </span>
                {receipt.status === ReceiptStatusEnum.PAID ? (
                  <span className={paymentStatusStyle}>Paid</span>
                ) : (
                  <span className={pendingPaymentStyle}>Pending payment</span>
                )}
              </div>
            </button>
          </li>
        );
      })}
    </ul>
  );
};
